import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import DynamicImage from '../../dynamic-image'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Navigation, Zoom} from 'swiper/modules'
import {ProductImageAltTextContext} from '../../product-view'

const GallerySwiper = ({
    heroImageGroup,
    loadingStrategy = 'lazy',
    openModal,
    selectedIndex,
    handleGalleryNavigation,
    styles,
    swiperRef,
    variant = 'default',
    setIsModalGallerySwiper,
    subModelIdentifier,
}) => {
    const swiperStyles = useMultiStyleConfig('Swiper')
    const extraSwiperStyles = useMultiStyleConfig('ExtraSwiper', {variant})
    const handleSlideChange = (swiper) => {
        handleGalleryNavigation(swiper.activeIndex > selectedIndex)
    }
    const imageAltText = useContext(ProductImageAltTextContext)

    return (
        <Box
            data-testid="image-gallery-swiper"
            __css={swiperStyles}
            {...extraSwiperStyles.container}
        >
            <Swiper
                modules={[Navigation, Zoom]}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                onInit={(swiper) => swiper.slideTo(selectedIndex)}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper
                }}
                onSlideChange={handleSlideChange}
                zoom={true}
            >
                {heroImageGroup?.images?.map((img, i) => (
                    <SwiperSlide key={i}>
                        <Box
                            className="swiper-zoom-container"
                            {...styles.heroImage}
                            onClick={() => {
                                setIsModalGallerySwiper(true)
                                openModal(selectedIndex)
                            }}
                            data-testid="hero-image"
                        >
                            <DynamicImage
                                {...styles.dynamicImage}
                                src={`${img.disBaseLink || img.link}[?sw={width}&q=60]`}
                                imageProps={{
                                    alt: imageAltText ? imageAltText : img.alt,
                                    loading: loadingStrategy,
                                    aspectRatio: styles.dynamicImage?.ratio,
                                }}
                                subModelIdentifier={subModelIdentifier}
                            />
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    )
}

GallerySwiper.propTypes = {
    heroImageGroup: PropTypes.object,
    loadingStrategy: PropTypes.string,
    openModal: PropTypes.func,
    selectedIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    styles: PropTypes.object,
    swiperRef: PropTypes.object,
    variant: PropTypes.string,
    handleGalleryNavigation: PropTypes.func,
    setIsModalGallerySwiper: PropTypes.func,
    subModelIdentifier: PropTypes.string,
}

export default GallerySwiper
